import React from "react";
import AccessibleModal from "../../../../../components/global_components/AccessibleModal";
import InspectionRequestModalContent from "./InspectionRequestModalContent";

interface IProps {
  inspectionId: string;
  isOpen: boolean;
  onClose: () => void;
}
export default function InspectionRequestModal({ inspectionId, isOpen, onClose }: IProps) {
  return (
    <AccessibleModal
      isOpen={isOpen}
      onClose={onClose}
      dialogProps={{
        "aria-labelledby": "request-inspection-header",
      }}
    >
      <InspectionRequestModalContent inspectionId={inspectionId} onClose={onClose} />
    </AccessibleModal>
  );
}
